import { Validators } from "@angular/forms";
import { DynamicFormComponent } from "../../../shared/components/dynamic-form/dynamic-form.component";
import { isSameOrAfterValidator } from "../../../shared/validators/is-same-or-after.validator";
import { Asset, ContractAsset } from "./asset.type";

export function validateDates(event: { key: string; value: moment.Moment }, dynamicForm: DynamicFormComponent): void {
  const { key, value } = event;
  const { startDate, endDate } = dynamicForm.form.controls;
  if (key === "startDate" && value?.isValid()) {
    endDate.setValidators([Validators.required, isSameOrAfterValidator(startDate)]);
    endDate.updateValueAndValidity();
    dynamicForm.getQuestion("endDate").minDate = value?.toDate();
    if (endDate.disabled) {
      endDate.enable();
    } else {
      endDate.markAsTouched();
    }
  } else if (key === "startDate" && !value?.isValid()) {
    endDate.setValidators([]);
    endDate.updateValueAndValidity();
    dynamicForm.getQuestion("endDate").minDate = null;
    endDate.setValue(undefined);
    endDate.disable();
  }
}

export function isAsset(obj: Asset | ContractAsset): obj is Asset {
  return (obj as ContractAsset).asset === undefined;
}
